import Spinner from "./Spinner.jsx";
import QuagganEmoji from "./QuagganEmoji.jsx";

export default function PostGiveaway({
  disabled,
  isBusy,
  onSubmit,
  statusMessage,
  statusTone = "neutral",
}) {
  return (
    <div className="post-giveaway-panel">
      {isBusy && (
        <div className="post-giveaway-popup post-giveaway-popup-busy" aria-live="polite">
          <div className="post-giveaway-spinner-wrap">
            <Spinner compact size={68} />
          </div>
          <div className="post-giveaway-popup-message-row">
            <QuagganEmoji type="success" inline size={36} className="post-giveaway-popup-emoji" />
            <div className="post-giveaway-popup-text">Submitting giveaway</div>
          </div>
        </div>
      )}

      {!isBusy && statusMessage && (
        <div
          className={`post-giveaway-popup post-giveaway-status post-giveaway-status-${statusTone}`}
          aria-live="polite"
        >
          <div className="post-giveaway-popup-message-row">
            <QuagganEmoji
              type={statusTone === "error" ? "failure" : "success"}
              inline
              size={36}
              className="post-giveaway-popup-emoji"
            />
            <div className="post-giveaway-popup-text">{statusMessage}</div>
          </div>
        </div>
      )}

      <button
        type="button"
        className="names-btn primary post-giveaway-btn"
        disabled={disabled || isBusy}
        onClick={onSubmit}
      >
        <span>Submit</span>
        <span>Giveaway</span>
      </button>
    </div>
  );
}